/* eslint-disable */
import { useEffect, useState } from "react";
import "./Dashboard.css";
import HeaderSelectionHistoryDrivers from "../../components/HeaderSelectionHistoryDrivers/HeaderSelectionHistoryDrivers";
import GetDataTable from "../../hooks/HistoryDrivers/GetDataTable.js";
import TableHistoryGlobals from "../../components/DriverHistory/TableHistoryGlobals";
import TableHistoryIndividual from "../../components/DriverHistory/TableHistoryIndividual";
import TableHistoryIndividualSends from "../../components/DriverHistory/TableHistorySends";
export default function ListHistoryDriver() {
  const [FilterBy, setFilterBy] = useState("GlobalStatementsDrivers");
  const { GetInfoTable, dataTable, isLoading } = GetDataTable();

  useEffect(() => {
    GetInfoTable(FilterBy);
  }, [FilterBy]);

  return (
    <>
      <div style={{ padding: "10px" }}>
        <HeaderSelectionHistoryDrivers setFilterBy={setFilterBy} />
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              height: "100%",
              alignItems: "center",
            }}
          >
            <div class="spinner"></div>
          </div>
        ) : FilterBy === "GlobalStatementsDrivers" ? (
          <TableHistoryGlobals Globals={dataTable} />
        ) : FilterBy === "StatementsDrivers" ? (
          <TableHistoryIndividual Globals={dataTable} />
        ) : (
          <TableHistoryIndividualSends Globals={dataTable} />
        )}
      </div>
    </>
  );
}
